import { useEffect } from 'react';
import { handleSessionResponse } from '../utils';

const exchange = async () => {
	const params = new URLSearchParams(window.location.search);
	const resp = await fetch('/api/oauth/finish', {
		method: 'POST',
		headers: {
			'content-type': 'application/json'
		},
		body: JSON.stringify({
			code: params.get('code')
		})
	});
	const res = await resp.text();
	handleSessionResponse(res);
};

const OAuthExchange = () => {
	useEffect(() => {
		exchange().then(() => {
			window.location.href = window.location.origin;
		});
	}, []);
	return null;
};

export default OAuthExchange;
